import React from "react";
import type { useAffinityFormReturn } from "affinityForm";

import { HospitalConfigurationType } from "./types";

export const SettingsFormContext = React.createContext<Maybe<useAffinityFormReturn<HospitalConfigurationType>>>(null);
